import type { ApiFailureAction, PutAndWaitResult } from 'modules/global/generic.types';

/**
 * Narrows a {@link PutAndWaitResult} to its failure branch, so a saga reads either
 * `result.payload` as the success payload or as the {@link ApiFailureAction}'s error, with no
 * cast on either side.
 * @template U The type of the success payload
 * @param result The action `putAndWait` resolved with
 */
export const isApiFailure = <U>(result: PutAndWaitResult<U>): result is ApiFailureAction =>
  Boolean(result.error);
